import { AxiosError, AxiosResponse } from 'axios';
import { getSettings } from 'infrastructure/api/endpoints/settings';
import useApi from 'infrastructure/api/useApi';
import { useQuery } from '@tanstack/react-query';
import shouldRetryApiQuery from 'infrastructure/api/shouldRetryApiQuery';
import settingsKeys from '../data/settingsKeys';
import { SettingResponse } from '../types';

interface UseGetAllSettingsOptions {
  enabled?: boolean;
}

const useGetAllSettings = (
  onError?: (error: AxiosError) => void,
  { enabled = true }: UseGetAllSettingsOptions = {}
) => {
  const { requestApi } = useApi();

  return useQuery<SettingResponse>({
    enabled,
    queryKey: settingsKeys.allSettings,
    queryFn: () =>
      requestApi(getSettings, {
        method: 'GET',
      }).then((data: AxiosResponse<SettingResponse>) => data.data),
    meta: {
      onError,
    },
    retry: shouldRetryApiQuery,
    staleTime: 2000,
  });
};

export default useGetAllSettings;
